<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Post Transplant Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="recipientStatus"
              disabled
              label="Recipient Status"
              class="recipientStatus"
              :class="{ highlightField: isDifferent(recipientStatus, recipientStatusOATS) }"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="recipientStatusOATS"
              disabled
              label="Recipient Status"
              class="mandatory-field recipientStatus"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft' || recipientStatus?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="sourceOfInformation"
              disabled
              label="Source of Information"
              class="sourceOfInformation"
              :class="{ highlightField: isDifferent(sourceOfInformation, sourceOfInformationOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'alive with functional graft' && recipientStatus?.toLowerCase() !== 'graft failure'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'alive with functional graft' || recipientStatusOATS?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="sourceOfInformationOATS"
              disabled
              label="Source of Information"
              class="sourceOfInformation"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'">
            <ADSTextInput
              v-model="dateClinicVisit"
              disabled
              label="Date of Clinic Visit or Contact with Source"
              :class="{ highlightField: isDifferent(dateClinicVisit, dateClinicVisitOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'alive with functional graft'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'alive with functional graft'">
            <ADSTextInput
              v-model="dateClinicVisitOATS"
              disabled
              label="Date of Clinic Visit or Contact with Source"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'">
            <ADSTextInput
              v-model="comments"
              disabled
              label="Comments"
              :class="{ highlightField: isDifferent(comments, commentsOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'alive with functional graft'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'alive with functional graft'">
            <ADSTextInput
              v-model="commentsOATS"
              disabled
              label="Comments"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="returnedToChronicDialysis"
              disabled
              label="Returned to Chronic Dialysis"
              :class="{ highlightField: isDifferent(returnedToChronicDialysis, returnedToChronicDialysisOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'alive with functional graft'
          || organ?.toLowerCase() !== 'kidney'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="returnedToChronicDialysisOATS"
              disabled
              label="Returned to Chronic Dialysis"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="failureDate"
              disabled
              label="Failure Date"
              :class="{ highlightField: isDifferent(failureDate, failureDateOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'graft failure'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'graft failure'">
            <ADSTextInput
              v-model="failureDateOATS"
              disabled
              label="Failure Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
              :class="{ highlightField: isDifferent(serumCreatinine, serumCreatinineOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'alive with functional graft'
          || organ?.toLowerCase() !== 'kidney'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="serumCreatinineOATS"
              disabled
              label="Serum Creatinine"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="serumCreatinineDate"
              disabled
              label="Serum Creatinine Date"
              :class="{ highlightField: isDifferent(serumCreatinineDate, serumCreatinineDateOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'alive with functional graft'
          || organ?.toLowerCase() !== 'kidney'">
          </div>
          <div class="col-2" v-if="recipientStatusOATS?.toLowerCase() === 'alive with functional graft'
          && organ?.toLowerCase() === 'kidney'">
            <ADSTextInput
              v-model="serumCreatinineDateOATS"
              disabled
              label="Serum Creatinine Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="failureCause?.toLowerCase() === 'other'">
            <ADSTextInput
              v-model="failureCauseOther"
              disabled
              label="Failure Cause - Other"
              :class="{ highlightField: isDifferent(failureCauseOther, failureCauseOtherOATS) }"
            />
          </div>
          <div class="col-3" v-if="failureCause?.toLowerCase() !== 'other'">
          </div>
          <div class="col-2" v-if="failureCauseOATS?.toLowerCase() === 'other'">
            <ADSTextInput
              v-model="failureCauseOtherOATS"
              disabled
              label="Failure Cause - Other"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="recipientStatus?.toLowerCase() === 'lost to follow-up'">
            <ADSTextInput
              v-model="lostFollowUpReason"
              disabled
              label="Lost to Follow-Up Reason"
              class="lostFollowUpReason"
              :class="{ highlightField: isDifferent(lostFollowUpReason, lostFollowUpReasonOATS) }"
            />
          </div>
          <div class="col-3" v-if="recipientStatus?.toLowerCase() !== 'lost to follow-up'">
          </div>
          <div class="col-3" v-if="recipientStatusOATS?.toLowerCase() === 'lost to follow-up'">
            <ADSTextInput
              v-model="lostFollowUpReasonOATS"
              disabled
              label="Lost to Follow-Up Reason"
              class="lostFollowUpReason"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';
import { ORGAN_LIST } from '../constants';

/** Mirrors backend ValueConversions.FOLLOWUP_RECIPIENT_STATUS (internal code → OATS label). */
const RECIPIENT_STATUS_OATS_LABEL_BY_CODE = Object.freeze( {
  1: 'Alive with Functional Graft',
  2: 'Graft failure',
  3: 'Lost to follow-up',
  4: 'Recipient death',
} );

/** Mirrors backend ValueConversions.FOLLOWUP_SOURCE (internal code → label). */
const SOURCE_OF_INFORMATION_OATS_LABEL_BY_CODE = Object.freeze( {
  1: 'Acute Care hospital',
  2: 'CKD and/or PRI Clinic',
  3: 'Community Care Hospital',
  4: 'Dialysis Center',
  5: 'Family Practice',
  6: 'Transplant program',
  8: 'Out of Province Healthcare Provider',
  7: 'Other',
} );

/** Mirrors backend ValueConversions.FOLLOWUP_LOST_TO_REASON (internal code → label). */
const LOST_FOLLOW_UP_REASON_OATS_LABEL_BY_CODE = Object.freeze( {
  1: 'Recipient refused ongoing follow-up care',
  2: 'Transferred out of country',
  3: 'Transferred outside of Ontario',
  4: 'Transferred within Ontario',
  5: 'Unable to contact patient',
} );

/** Pairs [ internal, external ] — mirrors backend ValueConversions.GRAFT_FAILURE_CAUSE (non-liver). */
const GRAFT_FAILURE_CAUSE_OATS_DISPLAY_ROWS = Object.freeze( [
  [ '1', 'PRIMARY NON-FUNCTION' ],
  [ '2', 'VASCULAR THROMBOSIS' ],
  [ '8', 'RECURRENCE OF ORIGINAL DISEASE' ],
  [ '8', 'Recurrent Disease' ],
  [ '10', 'OTHER' ],
  [ '10', 'Graft Thrombosis' ],
  [ '10', 'Infection' ],
  [ '10', 'Biopsy Proven Isletitis' ],
  [ '10', 'Graft/Vascular Thrombosis' ],
  [ '10', 'Pancreatitis' ],
  [ '11', 'MULTI-ORGAN FAILURE' ],
  [ '14', 'INFECTION - VIRAL' ],
  [ '14', 'BK (Polyoma) Virus' ],
  [ '16', 'INFECTION - FUNGAL' ],
  [ '17', 'PYELONEPHRITIS' ],
  [ '18', 'SURGICAL COMPLICATIONS' ],
  [ '18', 'Anastomic Leak' ],
  [ '18', 'Bleeding' ],
  [ '21', 'CANCEROUS TUMOUR ON KIDNEY' ],
  [ '22', 'IMMUNOLOGICAL RESPONSE - DEVELOPED ANTIBODIES' ],
  [ '23', 'RENAL ARTERY STENOSIS' ],
  [ '24', 'DRUG TOXICITY - CYCLOSPORINE' ],
  [ '25', 'RENAL VEIN THROMBOSIS' ],
  [ '26', 'ACUTE TUBULAR NECROSIS (ATN)' ],
  [ '27', 'RENAL ARTERY THROMBOSIS' ],
  [ '33', 'UROLOGIC COMPLICATIONS' ],
  [ '33', 'Urological Complications' ],
  [ '34', 'UNKNOWN' ],
  [ '36', 'COMPLICATIONS OF DIABETES' ],
  [ '37', 'IMMUNOSUPPRESSIVE REGIMEN DISCONTINUED - MEDICAL REASONS' ],
  [ '39', 'INFARCTED KIDNEY' ],
  [ '41', 'LYMPHOPROLIFERATIVE DISEASE' ],
  [ '44', 'IMMUNOSUPPRESSIVE REGIMEN DISCONTINUED - NON MEDICAL REASONS (NON-ADHERENCE)' ],
  [ '46', 'OBSTRUCTION' ],
  [ '47', 'RENAL EMBOLISM' ],
  [ '48', 'CHRONIC ALLOGRAFT NEPHROPATHY' ],
  [ '49', 'LYMPHOMA' ],
  [ '50', 'CHRONIC ALLOGRAFT DYSFUNCTION' ],
  [ '51', 'RENAL CELL CARCINOMA' ],
  [ '52', 'HYPERTENSION' ],
  [ '55', 'DRUG TOXICITY - TACROLIMUS' ],
  [ '61', 'DRUG TOXICITY - OTHER IMMUNOSUPPRESSANT(S)' ],
  [ '62', 'INFECTION - BACTERIAL' ],
  [ '63', 'Acute Rejection' ],
  [ '63', 'GRAFT REJECTION' ],
  [ '63', 'Hyperacute Rejection' ],
  [ '63', 'Chronic Rejection' ],
  [ '63', 'Chronic Rejection' ],
  [ '63', 'GRAFT REJECTION' ],
  [ '63', 'Chronic Rejection/Atherosclerosis' ],
  [ '64', 'NON-ADHERENCE' ],
  [ '64', 'Patient Noncompliance' ],
] );

/** Pairs [ internal, external ] — mirrors backend ValueConversions.GRAFT_FAILURE_CAUSE_LIVER. */
const GRAFT_FAILURE_CAUSE_LIVER_OATS_DISPLAY_ROWS = Object.freeze( [
  [ '1', 'PRIMARY NON-FUNCTION' ],
  [ '8', 'RECURRENCE OF ORIGINAL DISEASE' ],
  [ '8', 'Recurrent Disease' ],
  [ '10', 'OTHER' ],
  [ '10', 'Graft Thrombosis' ],
  [ '11', 'MULTI-ORGAN FAILURE' ],
  [ '14', 'INFECTION - VIRAL' ],
  [ '14', 'BK (Polyoma) Virus' ],
  [ '16', 'INFECTION - FUNGAL' ],
  [ '17', 'PYELONEPHRITIS' ],
  [ '18', 'SURGICAL COMPLICATIONS' ],
  [ '21', 'CANCEROUS TUMOUR ON KIDNEY' ],
  [ '22', 'IMMUNOLOGICAL RESPONSE - DEVELOPED ANTIBODIES' ],
  [ '23', 'RENAL ARTERY STENOSIS' ],
  [ '24', 'DRUG TOXICITY - CYCLOSPORINE' ],
  [ '25', 'RENAL VEIN THROMBOSIS' ],
  [ '26', 'ACUTE TUBULAR NECROSIS (ATN)' ],
  [ '27', 'RENAL ARTERY THROMBOSIS' ],
  [ '33', 'UROLOGIC COMPLICATIONS' ],
  [ '34', 'UNKNOWN' ],
  [ '36', 'COMPLICATIONS OF DIABETES' ],
  [ '37', 'IMMUNOSUPPRESSIVE REGIMEN DISCONTINUED - MEDICAL REASONS' ],
  [ '39', 'INFARCTED KIDNEY' ],
  [ '41', 'LYMPHOPROLIFERATIVE DISEASE' ],
  [ '44', 'IMMUNOSUPPRESSIVE REGIMEN DISCONTINUED - NON MEDICAL REASONS (NON-ADHERENCE)' ],
  [ '46', 'OBSTRUCTION' ],
  [ '47', 'RENAL EMBOLISM' ],
  [ '48', 'CHRONIC ALLOGRAFT NEPHROPATHY' ],
  [ '49', 'LYMPHOMA' ],
  [ '50', 'CHRONIC ALLOGRAFT DYSFUNCTION' ],
  [ '51', 'RENAL CELL CARCINOMA' ],
  [ '52', 'HYPERTENSION' ],
  [ '55', 'DRUG TOXICITY - TACROLIMUS' ],
  [ '61', 'DRUG TOXICITY - OTHER IMMUNOSUPPRESSANT(S)' ],
  [ '62', 'INFECTION - BACTERIAL' ],
  [ '63', 'GRAFT REJECTION' ],
  [ '63', 'Acute Rejection' ],
  [ '63', 'Chronic Rejection' ],
  [ '64', 'NON-ADHERENCE' ],
  [ '99', 'Biliary Tract Complications' ],
  [ '99', 'Diffuse Cholangiopathy' ],
  [ '99', 'Hepatic Outflow Obstruction' ],
  [ '99', 'Infection' ],
  [ '99', 'Patient Noncompliance' ],
  [ '99', 'Vascular Thrombosis' ],
  [ '8', 'Denovo Hepatitis' ],
  [ '6', 'Recurrent Disease' ],
  [ '8', 'Recurrent Hepatitis' ],
] );

function normFailureCauseOther( s ) {
  return s === null || s === undefined ? '' : String( s ).trim();
}

function externalMatchesOther( external, otherNorm ) {
  if( !otherNorm ) {
    return false;
  }
  return String( external ).trim().toUpperCase() === otherNorm.toUpperCase();
}

/**
 * Maps stored OATS internal graft_failure_cause (+ optional graft_failure_cause_other) to a display label.
 * Uses GRAFT_FAILURE_CAUSE_LIVER when organ is Liver, else GRAFT_FAILURE_CAUSE (same rules as backend ValueConversions).
 */
function failureCauseOatsDisplayLabel( internalCode, otherRaw, organ ) {
  if( internalCode === null || internalCode === undefined || internalCode === '' ) {
    return null;
  }
  const internalKey = String( internalCode );
  const rows = organ === 'Liver' ? GRAFT_FAILURE_CAUSE_LIVER_OATS_DISPLAY_ROWS : GRAFT_FAILURE_CAUSE_OATS_DISPLAY_ROWS;
  const candidates = rows.filter( ( [ i ] ) => i === internalKey );
  if( !candidates.length ) {
    return internalKey;
  }
  const otherNorm = normFailureCauseOther( otherRaw );
  if( otherNorm ) {
    const byOther = candidates.find( ( [ , ext ] ) => externalMatchesOther( ext, otherNorm ) );
    if( byOther ) {
      return byOther[ 1 ];
    }
  }
  const uniqueExternals = [ ...new Set( candidates.map( ( [ , e ] ) => e ) ) ];
  if( uniqueExternals.length === 1 ) {
    return uniqueExternals[ 0 ];
  }
  const allCapsRow = candidates.find( ( [ , ext ] ) => ext.length && ext === ext.toUpperCase() );
  if( allCapsRow ) {
    return allCapsRow[ 1 ];
  }
  return candidates[ 0 ][ 1 ];
}

export default {
  name: "PostTransplantPancreasSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      recipientStatus: this.getRecipientStatus( this.patientBundle ),
      recipientStatusOATS: this.getRecipientStatusOATS( this.patientBundleOATS, this.organ ),
      sourceOfInformation: this.getSourceOfInfo( this.patientBundle ),
      sourceOfInformationOATS: this.getSourceOfInfoOATS( this.patientBundleOATS, this.organ ),
      dateClinicVisit: this.getDateClinicVisit( this.patientBundle ),
      dateClinicVisitOATS: this.getDateClinicVisitOATS( this.patientBundleOATS, this.organ ),
      returnedToChronicDialysis: this.getReturnedToChronicDialysis( this.patientBundle ),
      returnedToChronicDialysisOATS: this.getReturnedToChronicDialysisOATS( this.patientBundleOATS, this.organ ),
      dateReturnedToChronicDialysis: this.getDateReturnedToChronicDialysis( this.patientBundle ),
      failureDate: this.getFailureDate( this.patientBundle ),
      failureDateOATS: this.getFailureDateOATS( this.patientBundleOATS, this.organ ),
      failureCause: this.getFailureCause( this.patientBundle ),
      failureCauseOATS: this.getFailureCauseOATS( this.patientBundleOATS, this.organ ),
      failureCauseOther: this.getFailureCauseOther( this.patientBundle ),
      failureCauseOtherOATS: this.getFailureCauseOtherOATS( this.patientBundleOATS, this.organ ),
      lostFollowUpReason: this.getLostFollowUpReason( this.patientBundle ),
      lostFollowUpReasonOATS: this.getLostFollowUpReasonOATS( this.patientBundleOATS, this.organ ),
      deathDate: this.getDeathDate( this.patientBundle ),
      causeDeathCategory: this.getCauseDeathCategory( this.patientBundle ),
      causeDeathType: this.getCauseDeathType( this.patientBundle ),
      serumCreatinine: this.getSerumCreatinine( this.patientBundle )?.toString(),
      serumCreatinineOATS: this.getSerumCreatinineOATS( this.patientBundleOATS, this.organ ),
      serumCreatinineDate: this.getSerumCreatinineDate( this.patientBundle )?.substring( 0,10 ),
      serumCreatinineDateOATS: this.getSerumCreatinineDateOATS( this.patientBundleOATS, this.organ ),
      causeDeathTypeOther: this.getCauseDeathTypeOther( this.patientBundle ),
      graftFunctioning: this.getGraftFunctioning( this.patientBundle ),
      comments: this.getComments( this.patientBundle ),
      commentsOATS: this.getCommentsOATS( this.patientBundleOATS, this.organ ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getRecipientStatus( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8087' );
    },
    getSourceOfInfo( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8088' );
    },
    getSerumCreatinine( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8060' );
    },
    getSerumCreatinineDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8061', 'valueDateTime' );
    },
    getDateClinicVisit( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8090', 'valueDateTime' );
    },
    getComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8091' );
    },
    getReturnedToChronicDialysis( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8139' );  
    },
    getDateReturnedToChronicDialysis( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8138', 'valueDateTime' );
    },
    getFailureDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8158', 'valueDateTime' );
    },
    getFailureCause( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8155', 'valueCodeableConcept.text' );
    },
    getFailureCauseOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
        const row = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ];
        const code = row?.graft_failure_cause;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return failureCauseOatsDisplayLabel( code, row?.graft_failure_cause_other, organ );
      }
      if( followUps && followUps.length > 1 ) {
        followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
        const row = followUps[ 0 ];
        const code = row?.graft_failure_cause;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return failureCauseOatsDisplayLabel( code, row?.graft_failure_cause_other, organ );
      }
      return null;
    },
    getFailureCauseOther( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8161', );
    },
    getLostFollowUpReason( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8162', );
    },
    getDeathDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#7933', 'valueDateTime' );
    },
    getCauseDeathCategory( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#7935', );
    },
    getCauseDeathType( patientBundle ) {
      const causeOfDeathTypeCodes = [
        'SK#7938', 'SK#7939', 'SK#7940', 'SK#7941', 'SK#7942', 'SK#7943', 'SK#7944',
        'UHN#3849', 'SK#7945', 'SK#7946', 'SK#7947', 'SK#7948', 'SK#7949',
      ];

      for( const code of causeOfDeathTypeCodes ) {
        const value = this.getSmartdataComponentValue( patientBundle, code );
        if( value !== null ) {
          return value;
        }
      }

      return null;
    },
    getCauseDeathTypeOther( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#7950', );
    },
    getGraftFunctioning( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8189', );
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
    },
    getRecipientStatusOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
        const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.recipient_status_code;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        const key = Number( code );
        return RECIPIENT_STATUS_OATS_LABEL_BY_CODE[ key ] ?? String( code );
      }
      if( followUps && followUps.length > 1 ) {
        followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
        const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.recipient_status_code;
      if( code === null || code === undefined || code === '' ) {
        return null;
      }
      const key = Number( code );
      return RECIPIENT_STATUS_OATS_LABEL_BY_CODE[ key ] ?? String( code );
      }
      return null;
    },
    getSourceOfInfoOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
        const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.source_of_followup;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        const key = Number( code );
        return SOURCE_OF_INFORMATION_OATS_LABEL_BY_CODE[ key ] ?? String( code );
      }
      if( followUps && followUps.length > 1 ) {
        followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
        const code = followUps[ 0 ]?.source_of_followup;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        const key = Number( code );
        return SOURCE_OF_INFORMATION_OATS_LABEL_BY_CODE[ key ] ?? String( code );
      }
      return null;
    },
    getSerumCreatinineOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.serum_creatinine;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.serum_creatinine;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code;
        }
        return null;
    },
    getCommentsOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.comments;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.comments;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code;
        }
        return null;
    },
    getSerumCreatinineDateOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.date_serum_creatinine;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.date_serum_creatinine;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code;
        }
        return null;
    },
    getDateClinicVisitOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
        if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.follow_up_date;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.follow_up_date;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code;
        }
        return null;
    },
    getReturnedToChronicDialysisOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.returned_to_chronic_dialysis;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code === 'U' ? 'Unknown' : code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.returned_to_chronic_dialysis;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code === 'U' ? 'Unknown' : code;
        }
        return null;
    },
    getFailureDateOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.graft_failure_date;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.graft_failure_date;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code;
        }
        return null;
    },
    getFailureCauseOtherOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
          const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.graft_failure_cause_other;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        return code;
        }
        if( followUps && followUps.length > 1 ) {
          followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
          const code = followUps[ 0 ]?.graft_failure_cause_other;
          if( code === null || code === undefined || code === '' ) {
            return null;
          }
          return code;
        }
        return null;
    },
    getLostFollowUpReasonOATS( patientBundleOATS, organ ) {
      const organCode = ORGAN_LIST?.[ organ ] ?? organ;
      const organCodeNum = organCode === null || organCode === undefined ? undefined : Number( organCode );
      const journey = patientBundleOATS?.journeys?.filter( ( n ) => ( n.organ_code === organCodeNum && n.state !== 'cancelled' && n.stage === 'post-transplant' ) );
      const followUps = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups;
      if( followUps && followUps.length === 1 ) {
        const code = journey?.[ 0 ]?.stage_attributes?.post_transplant?.follow_ups?.[ 0 ]?.lost_to_followup_reason;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        const key = Number( code );
        return LOST_FOLLOW_UP_REASON_OATS_LABEL_BY_CODE[ key ] ?? String( code );
      }
      if( followUps && followUps.length > 1 ) {
        followUps.sort( ( a, b ) => new Date( b.updated_at ) - new Date( a.updated_at ) );
        const code = followUps[ 0 ]?.lost_to_followup_reason;
        if( code === null || code === undefined || code === '' ) {
          return null;
        }
        const key = Number( code );
        return LOST_FOLLOW_UP_REASON_OATS_LABEL_BY_CODE[ key ] ?? String( code );
      }
      return null;
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 740px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1240px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
width: 320px;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.comments .afflo-ds-form-control) {
  width: 330px;
}

:deep(.recipientStatus .afflo-ds-form-control) {
  width: 330px;
}

:deep(.sourceOfInformation .afflo-ds-form-control) {
  width: 280px;
}

:deep(.failureCause .afflo-ds-form-control) {
  width: 280px;
}

:deep(.lostFollowUpReason .afflo-ds-form-control) {
  width: 330px;
}

:deep(.mandatory-field label::after) {
  content: " *";
  color: red;
}

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

</style>
